import "./Itsolutionpage.css";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function Detaileview() {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 230, behavior: "smooth" });
    }, 100); // Delay allows DOM to settle
  }, []);

  const location = useLocation(); // Initialize location first
  const [submenuOpen, setSubmenuOpen] = useState(false);

  const { title = "", description = "", imageUrl = "" } = location.state || {};

  // Function to split the description into multiple parts considering full stops
  const splitDescriptionBySentences = (text, wordLimit) => {
    const words = text.split(" "); // Split the text into words by space
    let currentIndex = 0;
    const parts = [];

    // Helper function to find the index of the last full stop before the word limit
    const findLastFullStopIndex = (words, startIndex, wordLimit) => {
      let index = startIndex + wordLimit;

      // Ensure we don't go out of bounds, check if the index is within the array length
      while (index > startIndex && index <= words.length) {
        if (words[index - 1].endsWith(".")) {
          return index;
        }
        index--;
      }
      return startIndex + wordLimit; // If no full stop, return the default word limit
    };

    // Loop to create parts based on wordLimit and full stops
    while (currentIndex < words.length) {
      const nextPartEnd = findLastFullStopIndex(words, currentIndex, wordLimit);
      const part = words.slice(currentIndex, nextPartEnd).join(" ");
      parts.push(part);
      currentIndex = nextPartEnd; // Move to the next chunk
    }

    return parts;
  };

  // Split description into parts with up to 50 words and respecting full stops
  const parts = splitDescriptionBySentences(description, 50);

  // Example: The result will be an array of parts, each containing up to 50 words and ending at a full stop
  console.log(parts);

  // Extract first three parts:
  const [firstPart, secondPart, thirdPart] = parts.slice(0, 3);

  // Remaining parts after the first three:
  const remainingParts = parts.slice(3);

  // Function to handle the splitting of remaining parts
  const handleRemainingParts = (remainingParts) => {
    const resultParts = [];

    // Continue splitting the remaining parts
    remainingParts.forEach((part) => {
      const subParts = splitDescriptionBySentences(part, 50);
      resultParts.push(...subParts); // Add all subparts to the result
    });

    return resultParts;
  };

  // Process remaining parts with the same logic
  const finalRemainingParts = handleRemainingParts(remainingParts);

  // Display the first three parts and the final remaining parts
  console.log("First Part:", firstPart);
  console.log("Second Part:", secondPart);
  console.log("Third Part:", thirdPart);
  console.log("Remaining Parts:", finalRemainingParts);

  return (
    <div>
      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>
      {/* <!-- Navbar & Hero End -->
    <!-- Header Start --> */}
      <div className="container-fluid Detailedbanner bg-breadcrumb">
        <div
          className="container text-center py-5"
          style={{ maxWidth: "9000px" }}
        >
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            A Journey of Discovery
          </h4>
        </div>
      </div>
      {/* <!-- Header End --> */}

      {/* <!-- Modal Search Start --> */}
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Modal Search End --> */}

      <div class="container-fluid innercontain  terms eventdetail_inner overflow-hidden py-5">
        <div class="container">
          <div class="row g-4">
            <div class="col-lg-10 pb-5 m-auto order-2 order-lg-1">
              <div
                class="text-center mt-0 mx-auto wow fadeInUp"
                data-wow-delay="0.2s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.2s",
                  animationName: "fadeInup",
                }}
              >
                <h1 class="display-3 text-capitalize text-white">{title}</h1>
              </div>

              <div
                class="mt-0 mx-auto wow fadeInUp detailview_wrap"
                data-wow-delay="0.2s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.2s",
                  animationName: "fadeInup",
                }}
              >
                <div class="service-single__left-item imag_wrap">
                  <img class="d-block" src={imageUrl} alt="image" />
                </div>
                <div class="service-single__left-item destailcontent">
                  <p class="mb-20 mt-0 text-white justify-text">{firstPart}</p>
                  <p class="mb-20 mt-0 text-white justify-text">{secondPart}</p>
                  <p class="mb-20 mt-0 text-white justify-text">{thirdPart}</p>
                </div>
              </div>
              <>
                <div>
                  <div class="destailcontent">
                    <p class="mb-20 mt-0 text-white justify-text">
                      {remainingParts}
                    </p>
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <a
        href="#"
        class="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
    </div>
  );
}

export default Detaileview;
